export default __webpack_public_path__ + "static/media/grafema_nutrana_08.3485aab8.jpg";